import React from "react";
import classNames from "classnames";
import { Link } from "react-router-dom";
import numeral from 'numeral';
import withStyles from "@material-ui/core/styles/withStyles";
// import Tooltip from "@material-ui/core/Tooltip";
// import Favorite from "@material-ui/icons/Favorite";

import GridContainer from "../../../components/Grid/GridContainer.jsx";
import GridItem from "../../../components/Grid/GridItem.jsx";
import Card from "../../../components/Card/Card.jsx";
import CardHeader from "../../../components/Card/CardHeader.jsx";
import CardBody from "../../../components/Card/CardBody.jsx";
import CardFooter from "../../../components/Card/CardFooter.jsx";
import Button from "../../../components/CustomButtons/Button.jsx";

import styles from "../../../assets/jss/material-kit-pro-react/views/ecommerceSections/latestOffersStyle.jsx";

import tourImg from "../../../assets/img/bg-tour-detail.jpg";

const HotToursSection = props => {
    const { classes } = props;
    return (
        <div className={classes.section}>
            <div className={classes.container}>
                <h3>Tours destacados</h3>
                <GridContainer>
                    <GridItem md={4} sm={4}>
                        <Card pricing plain>
                            <CardHeader image plain>
                                <Link to="/tour/5bb42ae313a846c80ef764e1">
                                    <img
                                        src="https://static.vivamoselcampo.co/uploads/5bb42ae313a846c80ef764e1/photos/1538534388686.jpg"
                                        alt="Tour Avistamiento Aves"
                                        className={classes.centerImgTour}
                                    />
                                </Link>
                                <div
                                    className={classes.coloredShadow}
                                    style={{ backgroundImage: `url(${tourImg})`, opacity: 1 }}
                                />
                            </CardHeader>
                            <CardBody className={classes.textCenter} plain>
                                <Link to="/tour/5bb42ae313a846c80ef764e1">
                                    <h4 className={classes.cardTitle}>Tour para Avistamiento de Aves en un día</h4>
                                </Link>
                                <ul>
                                    <li>Arribo al municipio de Arcabuco</li>
                                    <li>Desayuno con almojabana típica</li>
                                    <li>Avistamiento en Reserva Rogitama</li>
                                    <li>Almuerzo con trucha</li>
                                    <li>Recorridos en el bosque</li>
                                </ul>
                            </CardBody>
                            <CardFooter plain>
                                <div className={classes.priceContainer}>
                                    <span className={classNames(classes.price)}><span className={classes.priceNumber}>COP$ {numeral(136850).format('0,0')}</span> promedio/persona</span>
                                </div>
                                <Link to="/tour/5bb42ae313a846c80ef764e1">
                                    <Button round color="success">
                                        Ver
                                    </Button>
                                </Link>
                            </CardFooter>
                        </Card>
                    </GridItem>
                    <GridItem md={4} sm={4}>
                        <Card pricing plain>
                            <CardHeader image plain>
                                <Link to="/tour/5bb4277f13a846c80ef75233">
                                    <img
                                        src="https://static.vivamoselcampo.co/uploads/5bb4277f13a846c80ef75233/photos/1538533924239.jpg"
                                        alt="Tour Artesanías en Barro"
                                        className={classes.centerImgTour}
                                    />
                                </Link>
                                <div
                                    className={classes.coloredShadow}
                                    style={{ backgroundImage: `url(${tourImg})`, opacity: 1 }}
                                />
                            </CardHeader>
                            <CardBody className={classes.textCenter} plain>
                                <Link to="/tour/5bb42ae313a846c80ef764e1">
                                    <h4 className={classes.cardTitle}>Tour Conocimiento de las Artesanías en Barro</h4>
                                </Link>
                                <ul>
                                    <li>Visita al Desierto de la Candelaria</li>
                                    <li>Recorrido de la zona rural de Ráquira</li>
                                    <li>Taller de Artesanías en Barro</li>
                                    <li>Recorrido al Monasterio de la Candelaria</li>
                                    <li>Taller vivencial de Amasijos Ancestrales</li>
                                </ul>
                            </CardBody>
                            <CardFooter plain>
                                <div className={classes.priceContainer}>
                                    <span className={classNames(classes.price)}><span className={classes.priceNumber}>COP$ {numeral(130900).format('0,0')}</span> promedio/persona</span>
                                </div>
                                <Link to="/tour/5bb4277f13a846c80ef75233">
                                    <Button round color="success">
                                        Ver
                                    </Button>
                                </Link>
                            </CardFooter>
                        </Card>
                    </GridItem>
                    <GridItem md={4} sm={4}>
                        <Card pricing plain>
                            <CardHeader image plain>
                                <Link to="/tour/5bb4269ce2d92ba0aabdcf3d">
                                    <img
                                        src="https://static.vivamoselcampo.co/uploads/5bb4269ce2d92ba0aabdcf3d/photos/1538533061334.jpg"
                                        alt="Plan Noche de Antaño"
                                        className={classes.centerImgTour}
                                    />
                                </Link>
                                <div
                                    className={classes.coloredShadow}
                                    style={{ backgroundImage: `url(${tourImg})`, opacity: 1 }}
                                />
                            </CardHeader>
                            <CardBody className={classes.textCenter} plain>
                                <Link to="/tour/5bb42ae313a846c80ef764e1">
                                    <h4 className={classes.cardTitle}>Plan Noche de Antaño</h4>
                                </Link>
                                <ul>
                                    <li>Merienda Típica de Bienvenida</li>
                                    <li>Tertulia alrededor de fogata natural</li>
                                    <li>Alojamiento 1 noche</li>
                                    <li>Caminata ecológica a la Cascada del Hayal</li>
                                    <li>Almuerzo Típico de la Región</li>
                                </ul>
                            </CardBody>
                            <CardFooter plain>
                                <div className={classes.priceContainer}>
                                    <span className={classNames(classes.price)}><span className={classes.priceNumber}>COP$ {numeral(162000).format('0,0')}</span> promedio/persona</span>
                                </div>
                                <Link to="/tour/5bb4269ce2d92ba0aabdcf3d">
                                    <Button round color="success">
                                        Ver
                                    </Button>
                                </Link>
                            </CardFooter>
                        </Card>
                    </GridItem>

                    <GridItem md={7} sm={12} className={classNames(classes.divButtonMore)}>
                        <Link to="/tours">
                            <Button color="success" round block >
                                Ver todos los Tours
                            </Button>
                        </Link>
                    </GridItem>
                </GridContainer>
            </div>
        </div>
    );
};

export default withStyles(styles)(HotToursSection);



// WEBPACK FOOTER //
// ./src/views/LandingPage/Sections/HotToursSection.jsx